// extracted by mini-css-extract-plugin
export default {"hero":"AuthLayout_hero__2fObI","main":"AuthLayout_main__5GI59","auth-card":"AuthLayout_auth-card__JlebV"};